<template>
    <div :ref="stepName">
        <div class="form-header">
            <p><strong>Gefeliciteerd, voortaan ben je Supporter van Testaankoop.</strong></p>
            <p>Om toegang te krijgen tot alle diensten, onze magazines en uw welkomstgeschenk te ontvangen, vult u de volgende velden in:</p>
        </div>
        <AddressForm></AddressForm>
    </div>
</template>

<script>
import AddressForm from "./AddressForm";
import mixin from "../../../travel_step_mixin";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: { AddressForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
